// Re-export from refactored search module
// 기존 import path 호환성 유지: import SearchModal from '@/components/SearchModal'
export { default } from './search/SearchModal';
